import { getHints } from 'platform-components/src/components/user/selectors';
import { createSelector } from 'reselect';

import { getCurrentTeamLevel } from 'common.components/user/selectors';
import { getSubjectConfigList } from 'store/subject-config/selectors';
import { getSubjectFromProps } from 'utils/selectors/selectors';

import { ReduxTeacherStore } from '../../typings';

import { SEEN_LIBRARY_UPDATES_MODAL } from './constants';
import { LibraryUpdatesModalStore } from './typings';

const modalStoreSelector = (storeState: ReduxTeacherStore): LibraryUpdatesModalStore => storeState.libraryUpdatesModal;

export const getShouldLibraryUpdatesModal = createSelector(
    [getHints, getSubjectConfigList, getCurrentTeamLevel, getSubjectFromProps],
    // eslint-disable-next-line max-params
    (hints, configList, level, subject): boolean => {
        if (!level || !hints || hints[SEEN_LIBRARY_UPDATES_MODAL]) {
            return false;
        }

        return configList.some(
            (item) => item.subject === subject && item.show_library_updates_modal_to_grades?.includes(level)
        );
    }
);

export const getWasModalClosed = createSelector([modalStoreSelector], (store): boolean => store.modalWasClosed);
